<template>
  <div class="padding">
    <div v-if="!submited">
      <div
        class="text-center no-data"
        v-if="!$store.state.slide.title && !$store.state.slide.titleDesc"
      >
        {{ $t("blankSlide") }}
      </div>
      <h2
        class="mt-0 text-left slide-title-style"
        v-if="$store.state.slide.title || $store.state.slide.title !== ' '"
        :inner-html.prop="$store.state.slide.title | sanitize(true)"
      />
      <p
        class="mb-3 text-left title-desc slide-title-style"
        v-if="$store.state.slide.titleDesc"
      >
        {{ this.$store.state.slide.titleDesc }}
      </p>
      <div
        class="audio-control-slide"
        v-if="state.slide.audioLink && state.slide.audioPlayOnAudience && state.slide.id"
      >
        <AudioControl />
      </div>

      <ProgressBarTimer />

      <div class="slide-img-wrapper" v-if="$store.state.slide.image">
        <Loading v-if="isLoading" />
        <img
          :src="$store.state.slide.image.large"
          alt
          class="slide-img"
          ref="slide-imgg"
          @load="_imgLoaded"
          v-else
        >
      </div>
      <div class="text-area" :class="{error: error}">
        <textarea
          rows="4"
          v-model="text"
          :maxlength="limitText"
          :placeholder="$t('open-endedPlaceholder')"
        />
        <div class="count-text">
          {{ limitText - text.length }}
        </div>
      </div>
      <div
        class="label"
        v-if="$store.state.slide.openEndedMultipleOption && !isFirstTimeSubmit"
      >
        {{ $t("submitMultipleTimes") }}
      </div>
      <div
        class="submited"
        v-if="isFirstTimeSubmit && !submited"
      >
        {{ $t("open-endedInstructionSubmission") }}
      </div>

      <!-- Additional fields -->
      <div
        class="audience-form"
        v-if="$store.state.slide.additionalFields && $store.state.slide.additionalFields.length"
      >
        <div v-for="(item, index) in $store.state.slide.additionalFields" :key="index">
          <div class="input-label">
            <span v-if="item.label">
              <span>{{ item.label }}</span>
              <span v-show="item.required" class="pl-1 text-danger">*</span>
            </span>
          </div>
          <div v-if="item.type == 'name'">
            <!-- Name -->
            <div
              class="item-input"
              :class="{error: invalidAudienceName}"
            >
              <input
                type="text"
                class="item-input-text"
                maxlength="20"
                :disabled="checkDisableAudienceName()"
                id="openended-name"
                v-model="audienceName"
              >
              <div class="item-input-limit" v-if="!checkDisableAudienceName()">
                {{ 20 - audienceName.length }}
              </div>
            </div>
            <div class="text-danger" v-if="invalidAudienceName">
              {{ $t("mandatoryFieldError") }}
            </div>
          </div>

          <div v-if="item.type == 'team'">
            <!-- Team -->
            <div class="item-input" :class="{error: invalidAudienceTeam}">
              <input
                type="text"
                class="item-input-text"
                maxlength="20"
                :disabled="checkDisableAudienceTeam()"
                id="openended-team"
                v-model="audienceTeam"
              >
              <div class="item-input-limit" v-if="!checkDisableAudienceTeam()">
                {{ 20 - audienceTeam.length }}
              </div>
            </div>
            <div class="text-danger" v-if="invalidAudienceTeam">
              {{ $t("mandatoryFieldError") }}
            </div>
          </div>

          <div v-if="item.type == 'email'">
            <!-- Email -->
            <div class="item-input" :class="{error: invalidAudienceEmail}">
              <input
                type="email"
                class="item-input-text"
                maxlength="60"
                :disabled="checkDisableAudienceEmail()"
                id="openended-email"
                v-model="audienceEmail"
              >
              <div class="item-input-limit" v-if="!checkDisableAudienceEmail()">
                {{ 60 - audienceEmail.length }}
              </div>
            </div>
            <div class="text-danger" v-if="invalidAudienceEmail">
              <span v-if="invalidEmailText !== ''">{{ invalidEmailText }}</span>
              <span v-else>{{ $t("mandatoryFieldError") }}</span>
            </div>
          </div>

          <div v-if="item.type == 'avatar'">
            <!-- Emoji -->
            <div
              class="item-input audience-emoji"
              :class="{'disabled': state.isAudienceEmojiDisabled}"
            >
              <div class="pick-emoji" v-click-outside="clickOutSideEmoji">
                <div class="horizontal layout center" @click="openPickEmoji()">
                  <div class="emoji-picked" v-if="$store.state.audienceEmoji">
                    {{ $store.state.audienceEmoji }}
                  </div>
                  <div
                    v-if="!openEmoji"
                    class="text-action"
                    :class="{'white': $store.state.slide.textColour == '#ffffff'}"
                  >
                    {{ $t("changeButton") }}
                  </div>
                  <div
                    v-if="openEmoji"
                    class="text-action"
                    :class="{'white': $store.state.slide.textColour == '#ffffff'}"
                  >
                    {{ $t("closeAvatar") }}
                  </div>
                </div>
                <picker
                  :data="emojiIndex"
                  set="emojione"
                  v-show="openEmoji"
                  @select="addEmoji"
                  v-if="emojiIndex"
                  :native="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <ui-button
        block
        size="lg"
        class="mb-3"
        type="submit"
        @click="submit"
        :disabled="submiting || $store.state.slide.stopSubmission"
      >
        <template v-if="!this.$store.state.slide.stopSubmission">
          <span>
            {{ $t("submit") }}
            <CountDownTimer />
          </span>

          <i class="fas fa-check" v-if="!submiting" />
          <ui-spinner v-else />
        </template>

        <template v-if="$store.state.slide.stopSubmission">
          <span>{{ $t("submissionClosedButton") }}</span>
          <i class="fa fa-lock" />
        </template>
      </ui-button>

      <ui-button
        block
        size="lg"
        class="mb-3"
        @click="nextQuestion"
        variant="outline-primary"
        :disabled="checkNextSlide"
        v-show="isFirstTimeSubmit && !submited && !$store.state.presentation.audiencePacing"
      >
        <span>{{ $t("nextSlideButton") }}</span>
        <ui-spinner color="black" v-if="checkNextSlide" />
      </ui-button>

      <div class="stop-submission" v-if="this.$store.state.slide.stopSubmission">
        {{ $t("stopSubmission") }}
      </div>

      <div v-if="errorText" class="mb-3 text-center text-danger">
        {{ errorText }}
      </div>
    </div>
    <SlideWaiting v-if="submited" />
  </div>
</template>
<script>
import Config from '@/config'
import SlideWaiting from '@/components/SlideWaiting'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import Loading from '@/components/Loading'
import Util from '@/util'
import EvenBus from '@/eventBus'
import data from '@/assets/data/all.json'
import AudioControl from '@/components/AudioControl.vue'
import storage from '@/services/storage'
import CountDownTimer from '@/components/CountDownTimer'
import ProgressBarTimer from '@/components/ProgressBarTimer'
import * as Sentry from '@sentry/vue'
import audienceForm from '@/services/audienceForm'

// UI
import UiButton from '@/components/UI/Button'
import UiSpinner from '@/components/UI/Spinner'
import { mapState } from 'vuex'

export default {
  components: {
    UiButton,
    UiSpinner,
    SlideWaiting,
    Loading,
    Picker,
    AudioControl,
    ProgressBarTimer,
    CountDownTimer,
  },
  data() {
    return {
      submiting: false,
      text: '',
      limitText: 500,
      submited: false,
      isFirstTimeSubmit: false,
      error: false,
      checkNextSlide: false,
      errorText: '',
      isLoading: false,
      openEmoji: false,
      emojiIndex: null,
      audienceName: '',
      audienceTeam: '',
      audienceEmail: '',
      invalidAudienceName: false,
      invalidAudienceTeam: false,
      invalidAudienceEmail: false,
      invalidEmailText: '',
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
    }),
    state() {
      return this.$store.state
    },
  },
  watch: {
    '$store.state.slide': function handleSlideChange() {
      setTimeout(() => {
        if (this.$refs['slide-imgg'] && !this.$refs['slide-imgg'].complete) {
          this.isLoading = true
        }
      }, 1)

      if (typeof (this.$store.state.slide.additionalFields) === 'string') {
        this.$store.state.slide.additionalFields =
          JSON.parse(this.$store.state.slide.additionalFields)
        this.$store.dispatch('updateSlide', this.$store.state.slide)
      }
    },
  },
  mounted() {
    this.emojiIndex = new EmojiIndex(data)
    this.audienceName = this.$store.state.audienceName

    if (
      this.$store.state.slide.openEndedSubmited
      && !this.$store.state.slide.openEndedMultipleOption
    ) {
      this.submited = true
    }

    if (!this.$store.state.slide.additionalFields) {
      this.$store.state.slide.additionalFields = []
    }

    try {
      if (typeof (this.$store.state.slide.additionalFields) === 'string') {
        this.$store.state.slide.additionalFields =
          JSON.parse(this.$store.state.slide.additionalFields)
      }

      const presentationId = this.$store.state.presentation.id
      this.audienceTeam = storage.getValueByPresentation(presentationId, 'audienceTeam', '')
      this.$store.state.audienceTeam = this.audienceTeam

      this.audienceEmail = storage.getValueByPresentation(presentationId, 'audienceEmail', '')
      this.$store.state.audienceEmail = this.audienceEmail
    } catch (error) {
      this.$store.state.slide.additionalFields = []
    }

    setTimeout(() => {
      if (this.$store.state.audienceName) {
        const elName = document.getElementById('openended-name')
        if (elName) {
          elName.disabled = true
        }
      }
      if (this.$store.state.audienceTeam) {
        const elTeam = document.getElementById('openended-team')
        if (elTeam) {
          elTeam.disabled = true
        }
      }
      if (this.$store.state.audienceEmail) {
        const elEmail = document.getElementById('openended-email')
        if (elEmail) {
          elEmail.disabled = true
        }
      }
    }, 1000)
    this.checkSubmited()
  },
  methods: {
    checkSubmited() {
      const slideId = this.$store.state.slide.id
      const presentationId = this.$store.state.presentation.id
      const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
      if (answeredSlideIds.includes(slideId)) {
        if (this.$store.state.presentation.lastSlide === slideId &&
         !this.$store.state.slide.openEndedMultipleOption) {
          this.$store.state.slide.isEndSlide = true
        }
        this.$store.dispatch('updateSlide', this.$store.state.slide)
      }
    },
    checkDisableAudienceName() {
      if (this.$store.state.audienceName) return true
      return false
    },
    checkDisableAudienceTeam() {
      if (this.$store.state.audienceTeam) return true
      return false
    },
    checkDisableAudienceEmail() {
      if (this.$store.state.audienceEmail) return true
      return false
    },
    async submit() {
      this.error = false
      this.errorText = ''
      this.invalidEmailText = ''
      if (!this.text || this.submiting) {
        this.error = true
        return
      }

      const { presentation } = this.state
      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      const payload = {
        title: this.text,
        slideId: this.state.slide.id,
        audience: this.audienceId,
        presentationId: presentation.id,
        accessCode: presentation.uniqueAccessCode,
      }

      if (!Array.isArray(this.state.slide.additionalFields)) {
        this.state.slide.additionalFields = []
      }

      const { additionalFields } = this.state.slide
      let errorAdditionalField = false
      this.invalidAudienceName = false
      this.invalidAudienceTeam = false
      this.invalidAudienceEmail = false

      const audienceNameField = additionalFields.find((item) => item.type === 'name')
      const audienceTeamField = additionalFields.find((item) => item.type === 'team')
      const audienceEmailField = additionalFields.find((item) => item.type === 'email')
      const audienceAvatarField = additionalFields.find((item) => item.type === 'avatar')

      // validate audience name field
      if (audienceNameField && audienceNameField.required) {
        if (!this.audienceName || !this.audienceName.trim()) {
          errorAdditionalField = true
          this.invalidAudienceName = true
        }
      }

      // validate audience team field
      if (audienceTeamField && audienceTeamField.required) {
        if (!this.audienceTeam || !this.audienceTeam.trim()) {
          errorAdditionalField = true
          this.invalidAudienceTeam = true
        }
      }

      // validate audience email field
      if (audienceEmailField && audienceEmailField.required) {
        if (!this.audienceEmail || !this.audienceEmail.trim()) {
          errorAdditionalField = true
          this.invalidAudienceEmail = true
          return
        }
      }

      if (audienceEmailField) {
        if (!Util.validateEmail(this.audienceEmail) && this.audienceEmail.trim() !== '') {
          errorAdditionalField = true
          this.invalidAudienceEmail = true
          this.invalidEmailText = this.$t('invalidEmail')
          return
        }
      }

      // if one of the required fields are not fulfill
      // stop the submission process
      if (errorAdditionalField) return

      // get audience name value
      if (audienceNameField && this.audienceName && this.audienceName.trim()) {
        this.$store.state.audienceName = this.audienceName

        storage.setValueByPresentation(presentation.id, 'audienceName', this.audienceName)
        payload.audienceName = this.audienceName
      }

      // get audience team value
      if (audienceTeamField && this.audienceTeam && this.audienceTeam.trim()) {
        this.$store.state.audienceTeam = this.audienceTeam
        storage.setValueByPresentation(presentation.id, 'audienceTeam', this.audienceTeam)
        payload.audienceTeam = this.audienceTeam
      }

      // get audience email value
      if (audienceEmailField && this.audienceEmail && this.audienceEmail.trim()) {
        this.$store.state.audienceEmail = this.audienceEmail
        storage.setValueByPresentation(presentation.id, 'audienceEmail', this.audienceEmail)
        payload.audienceEmail = this.audienceEmail
      }

      // get audience avatar value
      if (audienceAvatarField) {
        storage.setValueByPresentation(presentation.id, 'audienceEmoji', this.state.audienceEmoji)
        payload.audienceEmoji = this.state.audienceEmoji
        this.state.isAudienceEmojiDisabled = true
      }

      this.submiting = true

      try {
        await this.$http.post(Config.api.createOpenEndedOption, payload)
        this.text = ''
        this.submiting = false
        this.isFirstTimeSubmit = true
        if (!this.$store.state.slide.openEndedMultipleOption) {
          this.submited = true
          this.$store.state.slide.openEndedSubmited = true
          this.$store.state.slide.submited = true
          if (this.$store.state.presentation.lastSlide === this.$store.state.slide.id) {
            this.$store.state.slide.isEndSlide = true
          }
          this.$store.dispatch('updateSlide', this.$store.state.slide)
        }

        const presentationId = this.$store.state.presentation.id
        const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
        answeredSlideIds.push(this.$store.state.slide.id)
        storage.setValueByPresentation(presentationId, 'answeredSlideIds', answeredSlideIds)

        Util.gaTrackEvent(
          'Open Ended Submit',
          'Audience submit',
          'Audience submit',
        )
        if (
          this.$store.state.presentation.audiencePacing
          && !this.$store.state.slide.openEndedMultipleOption
        ) {
          EvenBus.$emit('skipSlide')
        } else {
          EvenBus.$emit('confirmNextSlide')
        }
        audienceForm.updateAudienceData()
      } catch (error) {
        this.submiting = false
        if (error.body && error.body.message) {
          this.errorText = error.body.message

          Util.gaTrackEvent(
            'Open Ended Submit',
            'Audience submit fail',
            error.body.message,
          )
        } else {
          this.errorText = this.$t('openendedSubmissionFail')
          Util.gaTrackEvent(
            'Open Ended Submit',
            'Audience submit fail',
            JSON.stringify(error),
          )
        }
      }
    },

    async nextQuestion() {
      if (this.$store.state.presentation.audiencePacing) {
        EvenBus.$emit('skipSlide')
        return
      }
      this.checkNextSlide = true
      this.$store.state.slide.openEndedSubmited = true
      this.$store.state.slide.submited = true

      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      this.$http
        .get(Config.api.getPresentation + this.$store.state.presentation.uniqueAccessCode, {
          params: {
            audience: this.audienceId,
            continue: true,
          },
        })
        .then((res) => {
          this.checkNextSlide = false
          res.body = Util.formatSlide(res.body)
          if (res.body.additionalFields && typeof (res.body.additionalFields) === 'string') {
            res.body.additionalFields = JSON.parse(res.body.additionalFields)
          }
          Util.gaTrackEvent(
            'Open Ended Submit',
            'Audience Submit',
            'Audience choose Next Slide',
          )
          if (res.body.id !== this.$store.state.slide.id) {
            this.$store.dispatch('setSlide', res.body)
            EvenBus.$emit('hidePopupNextSlide', true)
            this.isFirstTimeSubmit = false
            this.submited = false
          } else {
            if (this.$store.state.presentation.lastSlide === this.$store.state.slide.id) {
              this.$store.state.slide.isEndSlide = true
              this.$store.dispatch('updateSlide', this.$store.state.slide)
            }
            this.submited = true
          }
        })
        .catch(Sentry.captureException)
    },

    _imgLoaded() {
      this.isLoading = false
    },

    openPickEmoji() {
      this.openEmoji = !this.openEmoji
    },

    clickOutSideEmoji() {
      if (this.openEmoji) {
        this.openEmoji = false
      }
    },

    addEmoji(emoji) {
      this.$store.state.audienceEmoji = emoji.native
      this.openEmoji = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.audio-control-slide {
  margin-bottom: 16px;
}
.no-data {
  padding: 16px;
}
.padding {
  padding: 0 16px;
}

.button-submit {
  margin-bottom: 16px;
}

.text-area {
  position: relative;

  textarea {
    width: 100%;
    padding: 10px;
    border-radius: 8px;
    border: 2px solid #ddd;
    -webkit-appearance: none;
    outline: none;
    padding: 10px 20px 10px 10px;
    margin-bottom: 16px;

    &:focus {
      border-color: $primary-color;
    }
  }

  .count-text {
    position: absolute;
    color: #313131;
    bottom: 26px;
    right: 9px;
    font-size: 12px;
  }

  &.error {
    textarea {
      border: 1px solid red;
      &:focus {
        border-color: red;
      }
    }

    .count-text {
      color: red;
    }
  }
}

.label,
.submited {
  text-align: center;
  color: inherit;
  margin-bottom: 16px;
  opacity: 0.7;
}

.slide-img-wrapper {
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 0.83em;
  display: flex;
  flex-direction: row;
  align-items: center;
  & /deep/ {
    .spinner {
      width: 120px;
      margin: 0 auto;
    }
    .spinner > div {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
}

.audience-form {
  .item-input {
    position: relative;
    margin-bottom: 16px;
    &.audience-emoji.disabled {
      .pick-emoji {
        cursor: not-allowed;
        .horizontal.layout {
          pointer-events: none;
        }
        .text-action {
          color: #ddd;
        }
      }
    }
  }
  .text-danger {
    text-align: left;
    margin-bottom: 16px;
    font-size: 13px;
  }
  .pick-emoji {
    position: relative;
    cursor: pointer;
    width: fit-content;
    -webkit-tap-highlight-color: transparent;

    .emoji-mart {
      position: absolute;
      top: 90px;
      left: 0;
      z-index: 110;
    }
  }

  .emoji-picked {
    font-size: 80px;
    margin: 0 16px;
  }

  .text-action {
    color: $primary-color;
    &.white {
      color: #fff;
      text-decoration: underline;
    }
  }
}
</style>
